import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  detailsTitle: {
    id: 'app.screens.BookScreen.detailsTitle',
    defaultMessage: 'APPOINTMENT DETAILS',
  },
  viewMap: {
    id: 'app.screens.BookScreen.viewMap',
    defaultMessage: 'View Map',
  },
});
